import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  setShowEmailList,
  setMentionList,
  fetchEmailList,
  SelectTemplate,
  clearAttachmentItem,
  sendMail,
  CreateDraftMessageForEmail,
  forwardMail,
} from "../../../../../Redux/Actions/actions";
import { Grid, Box, Stack, Button, Typography } from "@mui/material";
import { Package, XCircle, Paragraph } from "@phosphor-icons/react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { Input as BaseInput } from "@mui/base/Input";
import { styled } from "@mui/material/styles";
import { EditorProvider } from "@tiptap/react";
import { Color } from "@tiptap/extension-color";
import ListItem from "@tiptap/extension-list-item";
import TextStyle from "@tiptap/extension-text-style";
import Mention from "@tiptap/extension-mention";
import Image from "@tiptap/extension-image";
import Text from "@tiptap/extension-text";
import Document from "@tiptap/extension-document";
import Gapcursor from "@tiptap/extension-gapcursor";
import TextAlign from "@tiptap/extension-text-align";
import StarterKit from "@tiptap/starter-kit";
import suggestion from "../EditorProps/Suggestion";
import { ResizableImage } from "../EditorProps/ResizeFiles";
import MenuBar from "../EditorProps/Menubar";
import { Video, Pdf, ReplayMail } from "../EditorProps/CustomeNode";
import FileHandler from "@tiptap-pro/extension-file-handler";
import { MdDeleteForever } from "react-icons/md";
import { IoMdSend } from "react-icons/io";
import {
  regixToEmailAddress,
  regixCcEmailAddress,
  regixBccEmailAddress,
} from "../../../../Utils/Email-utils/email-utils";
import EmailAttachment from "./EmailAttachment";
import MenuList from "./MenuList";
import EmailBodyForward from "./EmailBodyForward";
import moment from "moment";
// subject custome input component
const Input = React.forwardRef(function CustomInput(props, ref) {
  return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
});
const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};
const InputElement = styled("input")(
  ({ theme }) => `
      width: 300px;
      font-family: 'IBM Plex Sans', sans-serif;
      font-size: 13px;
      font-weight: 400;
      line-height: 1.5;
      padding: 7px 12px;
      border-radius: 2px;
      color: ${grey[900]};
      background: ${"#fff"};
      border: 1px solid ${grey[200]};
      border-top:none;
      border-right:none;
      border-left:none;
      &:hover {
        border-top:none;
        border-right:none;
        border-left:none;
      }
   
    
      &:focus-visible {
        outline: 0;
        border-top:none;
        border-right:none;
        border-left:none;
      }
    `
);
const style = {
  control: (base, state) => ({
    ...base,
    fontSize: "13px",
    border: state.isFocused ? 0 : 0,
    boxShadow: state.isFocused ? 0 : 0,
    borderRadius: "0px",
    padding: "4px !important",
    "&:hover": {
      border: state.isFocused ? 0 : 0,
      borderBottom: "1px solid #c6c6c6b8",
    },
    borderBottom: "1px solid #c6c6c6b8",
    minHeight: "30px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    display: "none",
  }),
};
const mapStateToProps = (state) => {
  return {
    showEmailList: state.email.showEmailList,
    selectedMail: state.email.selectedMail,
    emailListOption: state.email.emailListOption,
    templatelist: state.email.templatelist,
    attachment: state.email.attachment,
    mailType: state.email.mailType,
    forwardedMailList: state.email.forwardedMailList,
  };
};

const SendMailComponent = (props) => {
  const [html, setHTML] = useState(``);
  const [to, setto] = useState([]);
  const [Cc, setCc] = useState([]);
  const [Bcc, setBcc] = useState([]);
  const [subject, setsubject] = useState("");
  const [selectedtemplate, setselectedtemplate] = useState("");

  const handelReplayMail = () => {
    const client = JSON.parse(localStorage.getItem("client"));
    if (!html) return;
    let formdata = new FormData();
    const toemail = to.map((item) => item.value);
    const Ccemail = Cc.map((item) => item.value);
    const Bccemail = Bcc.map((item) => item.value);
    const attachment = props.attachment.map((item) => ({
      url: item.attachmentUrl,
      download: item.filename,
    }));
    let requestID = "";
    if (props.selectedMail) {
      let tempStr = props.selectedMail.Email.subject;
      requestID = tempStr.slice(
        tempStr.indexOf("-") + 1,
        tempStr.lastIndexOf("]")
      );
    }

    switch (props.mailType) {
      case "Replay":
        formdata.append("email", toemail);
        formdata.append("ccData", Ccemail);
        formdata.append("bccData", Bccemail);
        formdata.append("subject", subject);
        formdata.append("attachmentUrls", JSON.stringify(attachment));
        formdata.append("html", html);
        formdata.append("receivedTime", props.selectedMail.Email.receivedTime);
        formdata.append("uid", props.selectedMail.Email.uid);
        formdata.append("agentID", client.user_id);
        formdata.append("requestId", requestID);
        formdata.append("ticketID", props.selectedMail.Email.ticketID);
        formdata.append("is_replyAll", false);
        props.sendMail(formdata);

        break;
      case "ReplyAll":
        formdata.append("email", toemail);
        formdata.append("ccData", Ccemail);
        formdata.append("bccData", Bccemail);
        formdata.append("subject", subject);
        formdata.append("attachmentUrls", JSON.stringify(attachment));
        formdata.append("html", html);
        formdata.append("receivedTime", props.selectedMail.Email.receivedTime);
        formdata.append("uid", props.selectedMail.Email.uid);
        formdata.append("agentID", client.user_id);
        formdata.append("requestId", requestID);
        formdata.append("ticketID", props.selectedMail.Email.ticketID);
        formdata.append("is_replyAll", true);
        props.sendMail(formdata);

        break;
      case "Forward":
        formdata.append("recipientEmail", toemail);
        formdata.append("ccData", Ccemail);
        formdata.append("bccData", Bccemail);
        formdata.append("forwardedSubject", subject);
        formdata.append("attachmentUrls", JSON.stringify(attachment));
        formdata.append("forwardedText", html);
        formdata.append("receivedTime", props.selectedMail.Email.receivedTime);
        formdata.append("uid", props.selectedMail.Email.uid);
        formdata.append("agentID", client.user_id);
        formdata.append("requestID", requestID);
        formdata.append("ticketID", props.selectedMail.Email.ticketID);
        formdata.append("is_replyAll", false);
        formdata.append(
          "originalEmail",
          JSON.stringify(props.forwardedMailList)
        );
        props.forwardMail(formdata);

        break;
      case "Edit":
        break;
      default:
        break;
    }
  };

  const wrapWithDiv = () => {
    const emailSignature = JSON.parse(localStorage.getItem("tokenAgent"));
    if (props.mailType == "Forward") {
      return `
        <br>
        <br>
        ${emailSignature.emailSignature}
      `;
    } else {
      const htmlValue = props.selectedMail ? props.selectedMail : "";
      if (!htmlValue) return;
      return `
            <br>
            <br>
            ${emailSignature.emailSignature}
            <div class="replaymail fs-11 mt-3 mb-3" style="padding: 10px;">
            <span><b>From :</b> ${htmlValue.Email.fromList}</span><br>
                <span><b>Sent :</b> ${moment(htmlValue.Email.receivedTime).format("MMMM Do YYYY, h:mm:ss a")}</span><br>
                <span><b>To :</b> ${htmlValue.Email.toList}</span><br>
                <span><b>Subject :</b> ${htmlValue.Email.subject.substring(htmlValue.Email.subject.indexOf("]") + 2)}</span><br>
                <br>
                ${htmlValue.EmailBody}
            </div>
        `;
    }
  };

  useEffect(() => {
    props.SelectTemplate();
    props.fetchEmailList();

    switch (props.mailType) {
      case "Replay":
        if (
          props.selectedMail
            ? props.selectedMail.Email
              ? props.selectedMail.Email.status === "Replied"
              : ""
            : ""
        ) {
          setto(
            regixToEmailAddress(
              props.selectedMail ? props.selectedMail.Email.toList : ""
            )
          );
        } else {
          setto(
            regixToEmailAddress(
              props.selectedMail ? props.selectedMail.Email.fromList : ""
            )
          );
        }
        setsubject(props.selectedMail ? props.selectedMail.Email.subject : "");
        break;
      case "ReplyAll":
        if (
          props.selectedMail
            ? props.selectedMail.Email
              ? props.selectedMail.Email.status === "Replied"
              : ""
            : ""
        ) {
          setto(
            regixToEmailAddress(
              props.selectedMail ? props.selectedMail.Email.toList : ""
            )
          );
        } else {
          setto(
            regixToEmailAddress(
              props.selectedMail ? props.selectedMail.Email.fromList : ""
            )
          );
        }
        setCc(
          regixCcEmailAddress(
            props.selectedMail ? props.selectedMail.Email.ccList : ""
          )
        );
        setBcc(
          regixBccEmailAddress(
            props.selectedMail ? props.selectedMail.Email.bccList : ""
          )
        );
        setsubject(props.selectedMail ? props.selectedMail.Email.subject : "");
        break;
      case "Forward":
        return;
      case "Edit":
        return;
      default:
        return <></>;
    }

    return () => {
      setto([]);
      setCc([]);
      setBcc([]);
      setsubject("");
      setselectedtemplate("");
      setHTML(``);
    };
  }, []);

  return (
    <Grid container direction={"row"}>
      <Stack spacing={0.8} sx={{ height: "100%", width: "100%" }}>
        {/* header for close sendmail DialogBox */}
        <Box sx={{ width: "100%" }} className="p-2">
          <Stack
            direction="row"
            sx={{ width: "100%", height: "100%" }}
            alignItems={"center"}
            justifyContent={"end"}
          >
            {/* Discard btn  */}
            <Button
              size="small"
              className="me-1"
              variant="outlined"
              onClick={() => {
                props.setShowEmailList(true);
              }}
              startIcon={<MdDeleteForever />}
              disableElevation
              sx={{ textTransform: "Capitalize" }}
            >
              Discard
            </Button>

            {/* Send btn  */}
            <Button
              onClick={handelReplayMail}
              size="small"
              variant="contained"
              endIcon={<IoMdSend />}
              sx={{ textTransform: "Capitalize " }}
              disableElevation
            >
              Send
            </Button>
          </Stack>
        </Box>

        {/* to  */}
        <Grid container spacing={2}>
          <Grid md={1} class={"border-bottom fs-13 text-secondary p-2"}>
            To
          </Grid>
          <Grid md={11}>
            <CreatableSelect
              value={to}
              isMulti
              name="colors"
              components={{ MenuList }}
              options={props.emailListOption}
              className="basic-multi-select w-100"
              classNamePrefix="select"
              onChange={(e) => {
                setto(e);
              }}
              styles={style}
            />
          </Grid>
        </Grid>
        {/* cc,BCC,  */}
        <Grid container spacing={2} md={12}>
          {/* cc  */}
          <Grid md={1} class={"border-bottom fs-13 text-secondary p-2"}>
            Cc
          </Grid>
          <Grid md={5} className="me-4">
            <CreatableSelect
              defaultValue={[]}
              value={Cc}
              isMulti
              name="colors"
              components={{ MenuList }}
              options={props.emailListOption}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={(e) => {
                setCc(e);
              }}
              styles={style}
            />
          </Grid>
          {/* Bcc  */}
          <Grid md={1} class={"border-bottom fs-13 text-secondary p-2"}>
            Bcc
          </Grid>
          <Grid md={5}>
            <CreatableSelect
              defaultValue={[]}
              value={Bcc}
              isMulti
              name="colors"
              components={{ MenuList }}
              options={props.emailListOption}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={(e) => {
                setBcc(e);
              }}
              styles={style}
            />
          </Grid>
        </Grid>
        {/* Subject , Template */}
        <Grid
          container
          spacing={2}
          md={12}
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          {/* Subject  */}
          <Grid
            xs="auto"
            className="me-4"
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-end"
              spacing={2}
            >
              <Grid
                md={2}
                class={"border-bottom fs-13 text-secondary p-1"}
                sx={{ padding: ".7rem", paddingTop: "10px!important" }}
              >
                Subject
              </Grid>
              <Input
                value={subject}
                aria-label="Demo input"
                disabled={
                  props.mailType == "Replay" || props.mailType == "ReplyAll"
                    ? true
                    : false
                }
                type="text"
                placeholder="Subject..."
                sx={{ padding: ".7rem" }}
                className="ms-0"
              />
            </Stack>
          </Grid>
          {/* template  */}
          <Grid md={4}>
            <Select
              type="button"
              name="colors"
              variant="outlined"
              options={props.templatelist}
              placeholder="Select template"
              className="basic-multi-select fs-13"
              classNamePrefix="select"
              onChange={(e) => {
                setselectedtemplate(e.value);
              }}
              styles={style}
            />
          </Grid>
        </Grid>

        {/* Attachment files will be preview here */}
        {props.attachment?.length > 0 && <EmailAttachment />}

        {/* editor */}
        <Grid xs={12} md={12} sm={12} item>
          <Stack spacing={1}>
            <Box
              className="main-mail"
              sx={{
                width: "100%",
              }}
              p={0.2}
            >
              <EditorProvider
                slotBefore={
                  <MenuBar
                    selectedtemplate={selectedtemplate}
                    setselectedtemplate={setselectedtemplate}
                  />
                }
                extensions={[
                  Document,
                  Paragraph,
                  Text,
                  Gapcursor,
                  ReplayMail,
                  Pdf,
                  Video,
                  Image,
                  ResizableImage,
                  Color.configure({ types: [TextStyle.name, ListItem.name] }),
                  TextStyle.configure({ types: [ListItem.name] }),
                  Mention.configure({
                    HTMLAttributes: { class: "mention" },
                    suggestion,
                  }),
                  StarterKit.configure({
                    bulletList: {
                      keepMarks: true,
                      keepAttributes: false,
                    },
                    orderedList: {
                      keepMarks: true,
                      keepAttributes: false,
                    },
                  }),
                  TextAlign.configure({
                    types: ["heading", "paragraph", "image", "video"],
                  }),
                  Image.configure({
                    inline: true,
                    allowBase64: true,
                  }),
                  FileHandler.configure({
                    onDrop: (currentEditor, files, pos) => {
                      files.forEach((file) => {
                        const fileReader = new FileReader();
                        if (file.type.startsWith("image/")) {
                          fileReader.readAsDataURL(file);
                          fileReader.onload = () => {
                            currentEditor
                              .chain()
                              .insertContentAt(pos, {
                                type: "image",
                                attrs: {
                                  src: fileReader.result,
                                },
                              })
                              .focus()
                              .run();
                          };
                        } else if (
                          file.type.startsWith("application/") ||
                          file.type.startsWith("text/")
                        ) {
                          fileReader.readAsDataURL(file);
                          fileReader.onload = () => {
                            currentEditor
                              .chain()
                              .insertContentAt(pos, {
                                type: "pdf",
                                attrs: {
                                  src: fileReader.result,
                                  title: file.name,
                                },
                              })
                              .focus()
                              .run();
                          };
                        } else if (file.type.startsWith("video/")) {
                          fileReader.readAsDataURL(file);
                          fileReader.onload = () => {
                            currentEditor
                              .chain()
                              .insertContentAt(pos, {
                                type: "video",
                                attrs: {
                                  src: fileReader.result,
                                },
                              })
                              .focus()
                              .run();
                          };
                        } else {
                          console.warn("Unsupported file type:", file.type);
                        }
                      });
                    },
                    onPaste: (currentEditor, files, htmlContent) => {
                      console.log("files types", files);
                      files.forEach((file) => {
                        if (htmlContent) {
                          console.log(htmlContent);
                          return false;
                        }

                        const fileReader = new FileReader();

                        if (file.type.startsWith("image/")) {
                          fileReader.readAsDataURL(file);
                          fileReader.onload = () => {
                            currentEditor
                              .chain()
                              .insertContentAt(
                                currentEditor.state.selection.anchor,
                                {
                                  type: "image",
                                  attrs: {
                                    src: fileReader.result,
                                  },
                                }
                              )
                              .focus()
                              .run();
                          };
                        } else if (
                          file.type.startsWith("application/") ||
                          file.type.startsWith("text/")
                        ) {
                          fileReader.readAsDataURL(file);
                          fileReader.onload = () => {
                            currentEditor
                              .chain()
                              .insertContentAt(
                                currentEditor.state.selection.anchor,
                                {
                                  type: "pdf",
                                  attrs: {
                                    src: fileReader.result,
                                    title: file.name,
                                  },
                                }
                              )
                              .focus()
                              .run();
                          };
                        } else if (file.type.startsWith("video/")) {
                          fileReader.readAsDataURL(file);
                          fileReader.onload = () => {
                            currentEditor
                              .chain()
                              .insertContentAt(
                                currentEditor.state.selection.anchor,
                                {
                                  type: "video",
                                  attrs: {
                                    src: fileReader.result,
                                  },
                                }
                              )
                              .focus()
                              .run();
                          };
                        } else {
                          console.warn("Unsupported file type:", file.type);
                        }
                      });
                    },
                  }),
                ]}
                onUpdate={({ editor }) => {
                  setHTML(editor.getHTML());
                  props.CreateDraftMessageForEmail(editor.getHTML());
                }}
                content={wrapWithDiv()}
              />
            </Box>

            {props.mailType == "Forward" && (
              <>
                {props.forwardedMailList.length > 0 &&
                  props.forwardedMailList.map((mail, index) => (
                    <EmailBodyForward key={index} mail={mail.Email} />
                  ))}
              </>
            )}
          </Stack>
        </Grid>
      </Stack>
    </Grid>
  );
};

export default connect(mapStateToProps, {
  setShowEmailList,
  setMentionList,
  fetchEmailList,
  SelectTemplate,
  clearAttachmentItem,
  sendMail,
  forwardMail,
  CreateDraftMessageForEmail,
})(SendMailComponent);
